import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function createGroupAPI(group) {
  const url = `${AWS_API_URL}/2n/groups`;
  return postRequest(url, { data: group }, await authorize());
}

